import './zone-geo-cell.scss';
import React from 'react';
import { RuleDataDao } from '../../../../dtos/version.dto';
import { RegionPopoverContent } from './region-popover-content';
import { DynamicPlacementPopover } from '../../../shared/dynamic-placement-popover/dynamic-placement-popover';
import getCountryFlag from '../../../../utils/countries-flags';
import { SystemConfiguration } from '../../../../utils/system-configuration';

interface ZoneProps {
    ruleData: RuleDataDao;
    maxRegionsToDisplay?: number;
}

export const ZoneGeoCell: React.FC<ZoneProps> = ({ ruleData, maxRegionsToDisplay = 5 }) => {

    const regionsByCode = SystemConfiguration.getInstance().getCountriesMapByCode;
    const regionsByName = SystemConfiguration.getInstance().getCountriesMapByName;
    const regionsLength = ruleData.address.regions?.length || 0;
    const additionalRegions = regionsLength - maxRegionsToDisplay;
    const regionRowHeight = 25;
    const sorted = ruleData.address.regions.map(region => regionsByCode[region].countryName)
        .sort((a, b) => a.localeCompare(b));

    const regionCell = <DynamicPlacementPopover content={<RegionPopoverContent regions={sorted}/>}
                                                contentHeight={regionsLength * regionRowHeight}>
        <div className={'zone-regions'}>
            {
                sorted.slice(0, maxRegionsToDisplay).map(region => {
                    const FlagSvg = getCountryFlag(regionsByName[region]?.countryCode);
                    return <div className="flag" key={region}>{FlagSvg && <FlagSvg/>}</div>;
                })
            }
            {additionalRegions > 0 && <div className={'additional-regions'}>+{additionalRegions}</div>}
        </div>
    </DynamicPlacementPopover>;

    return <div className={'zone-cell'}>
        {regionsLength ? regionCell : <></>}
    </div>;
};